<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">replay</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Reset playlist attempts for {{playlist.name}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card elevation="0">
      <v-card-title>
        {{confirmResetAttemptMessage}}
      </v-card-title>
    </v-card>
    <v-divider></v-divider>
    <v-card-actions class="row-space" style="height:56px">
      <v-btn flat class="branded-grey" @click="setDashModal(null)">Cancel</v-btn>
      <div class="row-center">
        <v-btn
          class="branded-background text-white"
          @click="resetPlaylistAttempts({'playlistId': playlist.id, sectionId:$route.query.section_id, learners: learnerIds})"
          :loading="playlistModalLoading">
          Reset
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ConfirmResetPlaylistAttempt',
  props: [
    'learner',
    'playlist',
  ],
  computed: {
    ...mapState('instructors', [
      'playlistModalLoading',
    ]),
    ...mapGetters('instructors', [
      'selectedData',
    ]),
    confirmResetAttemptMessage() {
      return `Would you like to reset the playlist attempt(s) for the ${this.selectedData.length ? this.selectedData.length : 1} selected student${this.selectedData.length > 1 ? 's' : ''}?`;
    },
    learnerIds() {
      if (this.learner) return this.learner;
      return this.selectedData.map(learner => learner.id);
    },
  },
  methods: {
    ...mapMutations([
      'setDashModal',
    ]),
    ...mapActions('instructors', [
      'resetPlaylistAttempts',
    ]),
  },
};
</script>


